<template>
    <div class="container" v-if="publisher">
        <div class="toolbar">
            <button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" id="yearsDropDown" data-bs-toggle="dropdown" aria-expanded="false">
                {{ this.selectedYear }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="yearsDropDown">
                <li v-for="year of availableYears" v-bind:key="year"><a class="dropdown-item" href="#" v-on:click="handleDropDownYearSelected(year)">{{ year }}</a></li>
            </ul>
            <button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" id="yearsDropDown" data-bs-toggle="dropdown" aria-expanded="false">
                {{ $t("enums.monthsByNumber." + this.selectedMonth) }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="monthDropDown">
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(1)">{{ $t("enums.months.january") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(2)">{{ $t("enums.months.february") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(3)">{{ $t("enums.months.march") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(4)">{{ $t("enums.months.april") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(5)">{{ $t("enums.months.may") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(6)">{{ $t("enums.months.june") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(7)">{{ $t("enums.months.july") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(8)">{{ $t("enums.months.august") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(9)">{{ $t("enums.months.september") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(10)">{{ $t("enums.months.october") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(11)">{{ $t("enums.months.november") }}</a></li>
                <li><a class="dropdown-item" href="#" v-on:click="handleDropDownMonthSelected(12)">{{ $t("enums.months.december") }}</a></li>
            </ul>
        </div>

        <div class="stats-grid">
            <div v-for="cell of this.cells" v-bind:key="cell.id" v-bind:class="cell.className">{{ cell.value}}</div>
        </div>

        <div class="bottom-toolbar">
            <router-link to="/admin/statistics">{{ $t("admin.overview.general_stats.more_details") }}</router-link>
        </div>
        <div class="static-notes alert alert-warning" v-html="$t('admin.static_notes.statistics_outdated')"></div>
    </div>    
</template>

<script>
import Publisher from "@/model/Publisher.js";
import StatisticsService from "@/service/StatisticsService.js";

export default {
    props: {
        publisher: Publisher
    },

    data() {
        return {
            selectedYear: new Date().getFullYear(),
            selectedMonth: new Date().getMonth() + 1,
            cells: null,
            statisticsService: new StatisticsService()
        }
    },

    computed: {
        availableYears() {
            var years = [];
            for (var year = 2021; year <= new Date().getFullYear(); year ++) {
                years.push(year);
            }

            return years;
        }
    },

    methods: {
        loadStats() {
            if (this.selectedMonth && this.selectedMonth) {
                this.statisticsService.loadPublisherMonthSummaryBasicStatistics(this.publisher.id, this.selectedYear, this.selectedMonth).then((basicStats) => {
                    const cells = [];

                    var isEven = false;
                    for (const statId in basicStats) {
                        cells.push({
                            id: statId,
                            className: "left-column" + (isEven ? " even" : " odd"),
                            value: this.$t("admin.statistics.names." + statId)
                        });

                        cells.push({
                            id: statId + "_value",
                            className: "right-column" + (isEven ? " even" : " odd"),
                            value: basicStats[statId]
                        });

                        isEven = !isEven;
                    }

                    if (cells.length == 0) {
                        cells.push({
                            id: "no-stats",
                            className: "no-stats-cell",
                            value: this.$t("admin.statistics.no_stats_for_period")
                        });
                    }

                    this.cells = cells;
                }).catch((error) => {
                    console.log(error);
                });
            }
        },

        handleDropDownYearSelected(year) {
            this.selectedYear = year;
            this.loadStats();
        },

        handleDropDownMonthSelected(month) {
            this.selectedMonth = month;
            this.loadStats();
        }
    },

    watch: {
        publisher: function(newValue, oldValue) {
            if (newValue != oldValue) {
                this.loadStats();
            }
        }
    },

    mounted() {
        this.loadStats();
    }
}
</script>

<style scoped>
.container {
    padding: 0px;
    text-align: left;
}

.toolbar button {
    margin-right: 8px;
}

.stats-grid {
    display: grid;
    grid-template-columns: auto auto;
    align-items: end;
    margin-top: 16px;
    font-size: 14px;
}

.stats-grid .left-column {
    font-weight: bold;
    padding: 4px 8px;
}

.stats-grid .right-column {
    font-size: 14px;
    padding: 4px 8px;
}

.odd {
    background-color: #f5f5f5;
}

.even {
    background-color: #ffffff;
}

.stats-grid .no-stats-cell {
    color: #777777;
    font-size: 18px;
    font-weight: bold;
    grid-column: 1 / span 2;
    margin: 32px 0px;
    text-align: center;
}

.bottom-toolbar {
    margin-top: 24px;
}
.static-notes {
  font-size: 0.8rem;
}
</style>
